// extracted by mini-css-extract-plugin
module.exports = {"menuIcon":"style_menuIcon__1b2to","disabledItem":"style_disabledItem__35Ux2"};